/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import {
    FETCH_LOTTERIES_START,
    FETCH_LOTTERIES_SUCCESS,
    FETCH_LOTTERIES_ERROR,
} from '../constants';
import mapLotteries from '../utils/index';

export default function fetchLotteries(exclusions = '') {
    return (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => {
        dispatch({ type: FETCH_LOTTERIES_START });
        return axios
            .get(`${process.env.API}/lottery/available`)
            .then((response) => {
                dispatch({
                    type: FETCH_LOTTERIES_SUCCESS,
                    payload: mapLotteries(response.data.lotteries, exclusions),
                });
            })
            .catch((error) => {
                dispatch({ type: FETCH_LOTTERIES_ERROR, error });
            });
    };
}
